import axios from './axiosInstances/axiosInstance';

export const addProductsFromFaveToBasket = (basketGuid, faveId) => {
  return axios.post(`baskets/${basketGuid}/products/fromFave`, {
    faveId,
  });
};
